const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      if (mutation.target.tagName === "PRODUCT-RECOMMENDATIONS") {
        relatedProductsSlider();
        // updatePrices();
        observer.disconnect();
        break;
      }
    }
  }
});

/*
const config = {
  childList: true,
  subtree: true,
};

// Disable observer in Theme Editor to prevent infinite loops
if (!(window.Shopify && window.Shopify.designMode)) {
  observer.observe(document.body, config);
}
*/

const facetContainer = document.querySelector(".facets-container");
const productFacets = document.getElementById(
  "main-collection-filters__container"
);
let facetHeight = 0;
let desktopFacetHeight = 0;
let facetScrollHeight = 0;
let desktopFacetScrollHeight = 0;

if (facetContainer) {
  facetHeight = facetContainer.offsetHeight;
  desktopFacetHeight = productFacets.offsetHeight;
  facetScrollHeight = facetContainer.getBoundingClientRect().top;
  desktopFacetScrollHeight = productFacets.getBoundingClientRect().top;
}
const breadcrumbMobile = document.querySelector(
  ".oj-main-product__breadcrumb-mobile"
);
if (breadcrumbMobile) {
  breadcrumbHeight = breadcrumbMobile.offsetHeight;
  breadcrumbScrollHeight = breadcrumbMobile.getBoundingClientRect().top;
}

document.addEventListener("scroll", function () {
  if (window.innerWidth < 750) {
    const breadcrumbMobile = document.querySelector(
      ".oj-main-product__breadcrumb-mobile"
    );
    if (breadcrumbMobile) {
      const scrollTop = window.pageYOffset;
      if (scrollTop >= breadcrumbScrollHeight) {
        breadcrumbMobile.classList.add("scroll-active");
      } else {
        breadcrumbMobile.classList.remove("scroll-active");
      }
    }
    // const productPageBreadcrumbs = document.querySelector('.oj-main-product__breadcrumb-mobile');
    // const scrollTop = window.pageYOffset;
    // if (facetContainer) {
    // 	if (scrollTop >= (facetScrollHeight - facetHeight)) {
    // 		facetContainer.parentNode.classList.add('active');
    // 		facetContainer.style.position = 'fixed';
    // 	} else {
    // 		facetContainer.parentNode.classList.remove('active');
    // 		facetContainer.style.position = 'static'
    // 	}
    // }
    // if (scrollTop > 0) {
    // 	productPageBreadcrumbs.classList.add('scroll-active');
    // } else {
    // 	productPageBreadcrumbs.classList.remove('scroll-active')
    // }
  } else {
    const productFacets = document.getElementById(
      "main-collection-filters__container"
    );
    const scrollTop = window.pageYOffset;
    if (scrollTop >= desktopFacetScrollHeight) {
      productFacets.classList.add("scroll-active");
    } else {
      productFacets.classList.remove("scroll-active");
    }
  }
});

if (window.innerWidth < 750) {
  let instaWidget = document.getElementById("insta-feed");
  if (instaWidget) {
    instaContainer = instaWidget.parentNode.parentNode;
    instaContainer.classList.remove("page-width");
  }
}

// Advertisement banner position change on mobile
if (window.innerWidth < 1025) {
  let gridContainer = document.getElementById("product-grid");
  let advertismentGrid = null;

  if (gridContainer) {
    advertismentGrid = gridContainer.querySelector(
      ".oj-plp__advertisment-banner-even"
    );

    if (advertismentGrid) {
      let siblingGrid = advertismentGrid.previousElementSibling;
      gridContainer.insertBefore(advertismentGrid, siblingGrid);
      gridContainer.insertBefore(siblingGrid, advertismentGrid.nextSibling);
    }
  }
}

//Disable quantity button for sold out variants in PDP
function disableQuantityInput() {
  const selectedVariant = event.target.previousElementSibling;
  const quantityButton = document.querySelector(
    '.oj-main-product .quantity__button[name="plus"]'
  );
  if (selectedVariant.classList.contains("disabled")) {
    quantityButton.classList.add("disabled");
    quantityButton.setAttribute("disabled", "");
  } else {
    quantityButton.classList.remove("disabled");
    quantityButton.removeAttribute("disabled");
  }
}

document.addEventListener("click", function (event) {
  if (
    event.target.matches(
      ".oj-product-variant__desktop label, variant-selects option"
    )
  ) {
    disableQuantityInput();
  }
});
